import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import ComeFunziona from "@/pages/ComeFunziona";
import PercheFarlo from "@/pages/PercheFarlo";
import Trasparenza from "@/pages/Trasparenza";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import NewReferral from "@/pages/NewReferral";
import ReferralDetail from "@/pages/ReferralDetail";
import Wallet from "@/pages/Wallet";
import Settings from "@/pages/Settings";
import Contract from "@/pages/Contract";
import Messages from "@/pages/Messages";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminReferrals from "@/pages/admin/AdminReferrals";
import AdminReferralDetail from "@/pages/admin/AdminReferralDetail";
import AdminPrograms from "@/pages/admin/AdminPrograms";
import AdminContracts from "@/pages/admin/AdminContracts";
import AdminReports from "@/pages/admin/AdminReports";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen bg-[#0A1128] flex items-center justify-center text-[#D4AF37]">Caricamento…</div>;
  if (!user) return <Navigate to="/accedi" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/come-funziona" element={<ComeFunziona />} />
            <Route path="/perche-farlo" element={<PercheFarlo />} />
            <Route path="/trasparenza" element={<Trasparenza />} />
            <Route path="/accedi" element={<Auth />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/registrati" element={<Auth mode="register" />} />

            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/segnala" element={<Protected><NewReferral /></Protected>} />
            <Route path="/segnalazioni/:id" element={<Protected><ReferralDetail /></Protected>} />
            <Route path="/compensi" element={<Protected><Wallet /></Protected>} />
            <Route path="/impostazioni" element={<Protected><Settings /></Protected>} />
            <Route path="/contratto" element={<Protected><Contract /></Protected>} />
            <Route path="/messaggi" element={<Protected><Messages /></Protected>} />

            <Route path="/admin" element={<Protected roles={["admin", "manager"]}><AdminDashboard /></Protected>} />
            <Route path="/admin/segnalazioni" element={<Protected roles={["admin", "manager", "agente"]}><AdminReferrals /></Protected>} />
            <Route path="/admin/segnalazioni/:id" element={<Protected roles={["admin", "manager", "agente"]}><AdminReferralDetail /></Protected>} />
            <Route path="/admin/programmi" element={<Protected roles={["admin", "manager"]}><AdminPrograms /></Protected>} />
            <Route path="/admin/contratti" element={<Protected roles={["admin", "manager"]}><AdminContracts /></Protected>} />
            <Route path="/admin/report" element={<Protected roles={["admin", "manager"]}><AdminReports /></Protected>} />
            <Route path="/admin/messaggi" element={<Protected roles={["admin", "manager", "agente"]}><AdminMessages /></Protected>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
